import { call, put, takeLatest } from "redux-saga/effects";
import {
  submitPaymentRequestTokenValidationRequest,
  submitPaymentValidationSuccess,
  submitPaymentValidationFailure,
  fetchPaymentListRequest,
  fetchPaymentListFailure,
  fetchPaymentListSuccess,
  fetchPaymentRequestsListFailure,
  fetchPaymentRequestsListRequest,
  fetchPaymentRequestsListSuccess,
  fetchPaymentStatusSuccess,
  fetchPaymentStatusFailure,
  fetchPaymentStatusRequest,
} from "../slices/payment-slice";
import {
  getPaymentRequests,
  getPaymentsList,
  postPaymentValidation,
  getPaymentStatus,
} from "../../services/payment.service";
import { ValidatePaymentRequest } from "../../models/request/validate-payment-request";
import { ValidatePaymentResponse } from "../../models/response/validate-payment-response";
import { PaymentStatusResponse } from "../../models/response/payment-status-response";
import { PaymentListResponse } from "../../models/response/payment-list-response";
import { PaymentRequestListResponse } from "../../models/response/payment-request-list-response";

// Worker Saga
function* validatePayment(action: {
  type: string;
  payload: ValidatePaymentRequest;
}) {
  try {
    const response: { data: ValidatePaymentResponse } = yield call(
      postPaymentValidation,
      action.payload,
    );

    yield put(submitPaymentValidationSuccess(response.data));
  } catch (error: any) {
    yield put(submitPaymentValidationFailure(error.message));
  }
}

function* fetchPaymentStatus(action: { type: string; payload: any }) {
  try {
    const response: { data: PaymentStatusResponse } = yield call(
      getPaymentStatus,
      action.payload,
    );

    yield put(fetchPaymentStatusSuccess(response.data));
  } catch (error: any) {
    yield put(fetchPaymentStatusFailure(error.message));
  }
}

function* fetchPaymentsList(action: {
  type: string;
  payload: { page: number; limit: number; status: string };
}) {
  try {
    const { page, limit, status } = action.payload;
    const response: { data: PaymentListResponse } = yield call(
      getPaymentsList,
      page,
      limit,
      status,
    );

    yield put(fetchPaymentListSuccess(response.data));
  } catch (error: any) {
    yield put(fetchPaymentListFailure(error.message));
  }
}

function* fetchPaymentRequests(action: {
  type: string;
  payload: { page: number; limit: number; status: string };
}) {
  try {
    const { page, limit, status } = action.payload;
    const response: { data: PaymentRequestListResponse } = yield call(
      getPaymentRequests,
      page,
      limit,
      status,
    );

    yield put(fetchPaymentRequestsListSuccess(response.data));
  } catch (error: any) {
    yield put(fetchPaymentRequestsListFailure(error.message));
  }
}

// Watcher Saga
export default function* paymentSaga() {
  yield takeLatest(
    submitPaymentRequestTokenValidationRequest.type,
    validatePayment,
  );
  yield takeLatest(fetchPaymentStatusRequest.type, fetchPaymentStatus);
  yield takeLatest(fetchPaymentListRequest.type, fetchPaymentsList);
  yield takeLatest(fetchPaymentRequestsListRequest.type, fetchPaymentRequests);
}
